'use strict';

/* globals define, document */

var jitsiApi;

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/conferences/conference-room', [
	'conference',
	'translator',
	'benchpress',
	RELATIVE_PATH_TRIMMED + '/conferences/conferences-list'
], function (conference, translator, Benchpress, conferencesList) {
	var	ConferenceRoom = {};

	ConferenceRoom.init = function () {
		conference.init(ajaxify.data.conference.roomName, ajaxify.data.jitsiServer, ajaxify.data.user.username, ajaxify.data.conference.jwt);

		$('[data-action="remove-conference"]').click(conferencesList.removeConference);
	};

	return ConferenceRoom;
});
